module.exports = __webpack_public_path__ + "static/media/vibepure-2.7af6fae3.jpg";